// FIXME: these helper accesses the document asap
export const getLang = () => document.head.getAttribute('data-lang') || 'en';
export const getLocale = () =>
  document.head.getAttribute('data-locale') || 'en_US';
export const getDomain = () => document.head.getAttribute('data-domain');
export const getCountry = () =>
  document.head.getAttribute('data-country') || 'US';
export const getCategoryId = () =>
  document.head.getAttribute('data-categoryid') || null;

export function getCsrfToken() {
  const meta = document.head.querySelector('meta[name=csrf-token]');
  return (meta && meta.content) || null;
}
